import React, { useState, useEffect } from 'react';
import styles from './changeLang.css';
import SwedishFlag from '../../../../../../../assets/svg/swedishFlag.svg';
import UkFlag from '../../../../../../../assets/svg/ukFlag.svg';
import NorwayFlag from '../../../../../../../assets/svg/norwayFlag.svg';
import DenmarkFlag from '../../../../../../../assets/svg/denmarkFlag.svg';
import FinnishFlag from '../../../../../../../assets/svg/finnishFlag.svg';
import RussianFlag from '../../../../../../../assets/svg/russianFlag.svg';
import SpanishFlag from '../../../../../../../assets/svg/spanishFlag.svg';
import ChineseFlag from '../../../../../../../assets/svg/chineseFlag.svg';
import ArrowDown from '../../../../../../../assets/svg/arrowDown.svg';
import Portugal from '../../../../../../../assets/svg/portugal.png';
import France from '../../../../../../../assets/svg/france.svg';
import Germany from '../../../../../../../assets/svg/germany.svg';
import India from '../../../../../../../assets/svg/india.svg';
import Italy from '../../../../../../../assets/svg/italy.svg';
import Japan from '../../../../../../../assets/svg/japan.svg';
import Korea from '../../../../../../../assets/svg/korea.png';
import Netherlands from '../../../../../../../assets/svg/netherlands.svg';
import Poland from '../../../../../../../assets/svg/poland.svg';
import Turkey from '../../../../../../../assets/svg/turkey.svg';
import { useSelector } from 'react-redux';
import { getLangIdByName, langList } from '../../../../../../../utils/func';

// order of icons should be the same as order of languages ID
const arrIcon = [
    <UkFlag className={ styles.svg }/>,
    <SwedishFlag className={ styles.svg }/>,
    <NorwayFlag className={ styles.svg }/>,
    <DenmarkFlag className={ styles.svg }/>,
    <FinnishFlag className={ styles.svg }/>,
    <RussianFlag className={ styles.svg }/>,
    <SpanishFlag className={ styles.svg }/>,
    <ChineseFlag className={ styles.svg }/>,
    <img className={ styles.png } src={ Portugal } alt='Portugal'/>,
    <Poland className={ styles.svg }/>,
    <Turkey className={ styles.svg }/>,
    <Netherlands className={ styles.svg }/>,
    <France className={ styles.svg }/>,
    <Germany className={ styles.svg }/>,
    <India className={ styles.svg }/>,
    <Italy className={ styles.svg }/>,
    <Japan className={ styles.svg }/>,
    <img className={ styles.png } src={ Korea } alt='Korea'/>
];

/**
 *
 * @param selectedLang
 * @param handleTemplateLanguageChange
 * @param disp
 * @returns {JSX.Element}
 * @constructor
 */

const ChangeLang = React.memo(( { selectedLang, handleTemplateLanguageChange, disp } ) => {

    const { localization: { lang } } = useSelector( ( state ) => state );
    const [ theSelectedLang, setSelectedLang ] = useState( 'English' );
    const [ display, setDisplay ] = useState( false );

    useEffect( () => {
        setSelectedLang( langList[ lang ] );
        handleTemplateLanguageChange( langList[ lang ] );
    }, [] );

    useEffect( () => {
        if ( selectedLang ) {
            setSelectedLang( selectedLang );
        }
    }, [ selectedLang ] );

    const changeLang = ( langName, display ) => {
        setSelectedLang( langName );
        setDisplay( !display );
        handleTemplateLanguageChange( langName );
    };

    const toggleDisplay = display || disp ? { borderRadius: '0 0 1rem 1rem' } : { display: 'none' };
    const borderInput = display ? { borderRadius: '1rem 1rem 0 0' } : {};
    const selectedFlag = arrIcon[ getLangIdByName( theSelectedLang ) - 1 ];

    const dropLangsList = () => {
        return Object.keys( langList ).map( ( langCode ) => {
            let langName = langList[ langCode ];
            return ( <p key={ langName } className={ styles.button }
                        onClick={ () => {
                            changeLang( langName, display );
                        } }>
                { arrIcon[ getLangIdByName( langName ) - 1 ] }
                <span className={ styles.text }>{ langName }</span>
            </p> );

        } );
    };

    return (
        <div className={ styles.wrapper }>
            <div
                style={ borderInput }
                className={ styles.boxInput }
                onClick={ () => {
                    setDisplay( !display );
                } }
            >
                { selectedFlag }
                <span className={ styles.input }>{ theSelectedLang }</span>
                <ArrowDown className={ styles.arrowDown }/>
            </div>
            <div
                className={ styles.wrapperButtons }
                style={ toggleDisplay }>
                { dropLangsList() }
            </div>
        </div>
    );

});

export default ChangeLang;